import { render } from "./TextAreaLangSegment.vue?vue&type=template&id=2dd76296"
import script from "./TextAreaLangSegment.vue?vue&type=script&lang=js"
export * from "./TextAreaLangSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__